let getPlanId = function() {	
	this.PlanPremium = (this.$store.getters['core/Org/getPlanId'] > 1);
	console.log('watch PlanPremium', this.PlanPremium);
};
export default getPlanId;
